var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn question-option-button",class:{'active': _vm.active === _vm.valueKey },attrs:{"role":"button"},on:{"click":function($event){return _vm.setActive()}}},[_c('span',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }